import React from "react";
import BrandLogo from "./BrandLogo";
import NavBarButtonGroup from "./NavBarButtonGroup";

export default function Navbar() {
  return (
    <>
      {/* <!-- navbar start  --> */}
      <nav className="py-4 border-b">
        <div className="navbar-container">
          {/* <!-- logo --> */}
          <BrandLogo />
          {/* <!-- auth buttons , This will nonfunctional, just for nice looking --> */}
          <NavBarButtonGroup />
        </div>
      </nav>
      {/* <!-- navbar end  --> */}
    </>
  );
}
